import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import PrototypeNav from '../components/WfhSurveyPrototype/PrototypeNav';
import SurveyList from '../components/WfhSurveyPrototype/admin/SurveyList';
import CreateCampaign from '../components/WfhSurveyPrototype/admin/CreateCampaign';
import CampaignDetail from '../components/WfhSurveyPrototype/admin/CampaignDetail';
import Welcome from '../components/WfhSurveyPrototype/employee/Welcome';
import StepWizard from '../components/WfhSurveyPrototype/employee/StepWizard';
import ThankYou from '../components/WfhSurveyPrototype/employee/ThankYou';
import { DeviceProvider } from '../components/WfhSurveyPrototype/DeviceContext';
import DevicePreview from '../components/WfhSurveyPrototype/DevicePreview';

/**
 * Entry point for the WFH & Commuting Survey prototype.
 *
 * Rendered from `App.js` when the path starts with `/prototype/wfh-survey` —
 * before auth, before branding, and before the main Router is mounted. Owns
 * its own BrowserRouter so the prototype can route independently.
 *
 * This is throw-away UI for stakeholder review; it does not use Redux, real
 * APIs, or MSW. All data is hardcoded in `components/WfhSurveyPrototype/fixtures.js`.
 *
 * Employee routes are wrapped in a {@link DevicePreview} so reviewers can
 * toggle between mobile / tablet / desktop previews without leaving the
 * page.
 */
const EmployeeRoute = ({ children }) => <DevicePreview>{children}</DevicePreview>;

const WfhSurveyPrototype = () => {
  return (
    <BrowserRouter>
      <DeviceProvider>
        <div className='min-h-screen bg-background'>
          <PrototypeNav />
          <div className='lg:ml-[260px]'>
            <Switch>
              <Route exact path='/prototype/wfh-survey'>
                <Redirect to='/prototype/wfh-survey/admin/list' />
              </Route>
              <Route path='/prototype/wfh-survey/admin/list'>
                <SurveyList />
              </Route>
              <Route path='/prototype/wfh-survey/admin/new'>
                <CreateCampaign />
              </Route>
              <Route path='/prototype/wfh-survey/admin/campaign/:id'>
                <CampaignDetail />
              </Route>
              <Route path='/prototype/wfh-survey/employee/welcome'>
                <EmployeeRoute>
                  <Welcome />
                </EmployeeRoute>
              </Route>
              <Route path='/prototype/wfh-survey/employee/step/:slug'>
                <EmployeeRoute>
                  <StepWizard />
                </EmployeeRoute>
              </Route>
              <Route path='/prototype/wfh-survey/employee/thank-you'>
                <EmployeeRoute>
                  <ThankYou />
                </EmployeeRoute>
              </Route>
              <Route>
                <Redirect to='/prototype/wfh-survey/admin/list' />
              </Route>
            </Switch>
          </div>
        </div>
      </DeviceProvider>
    </BrowserRouter>
  );
};

export default WfhSurveyPrototype;
